import styles from '@/admin/components/AdminToggle.module.scss';

type AdminToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
};

export const AdminToggle = ({ checked, onChange, disabled, label }: AdminToggleProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    className={`${styles.track} ${checked ? styles.trackOn : ''}`}
    onClick={() => onChange(!checked)}
  >
    <span className={`${styles.thumb} ${checked ? styles.thumbOn : ''}`} />
  </button>
);
